let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8o2F8")).then(() => parcelRequire('9TMai'));